<template>

    <div class="home-wrapper">

        <div class="home-intro">
            <div class="container-fluid">
                <div class="home-intro-inner">
                    <div class="row middle">
                        <div class="col-lg-offset-1 col-lg-8 col-md-offset-0 col-md-12">OUTRO
                            <p class="home-subtitle">{{ $t('home.subtitle') }}</p>

                            <div class="home-intro-content">
                                <h1 class="home-title"><span>Timeline</span> of
                                    <br> a <span>Genocide</span></h1>
                            </div>
                        </div>

                        <div class="col-lg-3 col-md-12">
                            <router-link :to="{ name: 'story', params: { locale: this.$i18n.locale }}" class="home-intro-button">
                                <span>go to story</span>
                            </router-link>
                        </div>
                    </div>

                </div>
            </div>

            <p class="home-intro-bottom">
                scroll for Prologue

                <svg xmlns="http://www.w3.org/2000/svg" width="8" height="102" viewBox="0 0 8 102"><g id="Group_207" data-name="Group 207" transform="translate(-678.7 -728)"><line id="Line_52" data-name="Line 52" y2="97" transform="translate(683 728)" fill="none" stroke="#fff" stroke-width="1"/><g id="Forward_arrow" data-name="Forward arrow" transform="translate(686.7 818) rotate(90)"><path id="Path_10" data-name="Path 10" d="M-1.692,0l-.671.671L.178,3.213H-10v.959H.178L-2.364,6.713l.671.671L2,3.692Z" transform="translate(10)" fill="#fff"/></g></g></svg>
            </p>
        </div>

        <div class="home-content">
            <div class="container-fluid home-content-intro">

                <div class="row center">
                    <div class="col-lg-8 col-md-12">

                        <p class="home-content-heading">
                            Srebrenica, a town in eastern Bosnia, was an enclave under the control of the army of Bosnian Muslims (BiH Army) during most of the 1992-95 conflict in Bosnia and Herzegovina (BiH).
                        </p>

                    </div>
                </div>

                <div class="home-content-group">
                    <div class="row">

                        <div class="col-lg-offset-1 col-lg-5 col-md-offset-0 col-md-6 col-sm-12">
                            <div class="home-content-image">
                                <div class="home-content-image-group">
                                    <img src="/images/kravica-warehouse.jpg" alt="">

                                    <p class="home-content-image-caption">Etiam convallis elementum sapien, a aliquam turpis aliquam vitaeat</p>
                                </div>
                            </div>
                        </div>

                        <div class="col-lg-offset-1 col-lg-4 col-md-offset-0 col-md-6 col-sm-12">
                            <div class="home-content-text">
                                During that period, it housed tens of thousands of Bosnian Muslims from surrounding areas who fled their homes because of attacks of Serbian forces. For three years, Bosnian Serbs besieged the enclave, frequently shelling it, while Bosnian Muslim forces operating from the enclave attacked surrounding Serb villages.
                                <br>
                                <br>
                                In April 1993 the United Nation Security Council adopted Resolution 819 declaring Srebrenica ‘safe area’ - a demilitarised zone under the protection of UNPROFOR. Around 40,000 Bosnian Muslim refugees from surrounding areas found shelter in Srebrenica. In a March 1995 directive, Radovan Karadžić, President of Republika Srpska instructed Bosnian Serb forces on the strategy to eliminate the Muslim population from the Srebrenica and Žepa enclaves. <a href="#">‘Directive 7’</a>, as it became known, served as a precursor to the crimes of July 1995.
                            </div>
                        </div>

                    </div>
                </div>
            </div>

            <div class="home-content-highlight">
                <div class="container-fluid">
                    <div class="home-content-highlight-inner">

                        <div class="home-content-highlight-text">
                            <div class="home-content-highlight-text-inner">
                                “ By planned and well-though-out combat operation create an unberable situation of total insecuriti with no hope of further survival or life for the inhabitans of Srebrenica and Žepa. ”
                            </div>
                        </div>

                        <div class="home-content-highlight-box">
                            up to
                            <span>8000</span>
                            victims
                        </div>
                    </div>
                </div>
            </div>

            <div class="home-content-helper">

                <div class="container-fluid">
                    <div class="home-content-group">
                        <div class="row">

                            <div class="col-lg-offset-1 col-lg-4 col-md-offset-0 col-md-6 col-sm-12">
                                <div class="home-content-text">
                                    In July 1995 Directive 7 transformed into a concrete plan, and Srebrenica was overrun by Serb forces. In the days following the take-over, members of Bosnian Serb Army and Police implemented a plan to kill men and boys and expel the women and children from the enclave.
                                    <br>
                                    <br>
                                    The International Tribunal for the former Yugoslavia (ICTY or Tribunal) and the International Residual Mechanism for Criminal Tribunals (IRMCT or Mechanism) tried 20 individuals for crimes committed in Srebrenica and found that the mass executions of Bosnian Muslim men and boys from Srebrenica constituted genocide.
                                    <br>
                                    <br>
                                    During the Srebrenica genocide up to 8,000 Muslim boys were killed or are still missing. Approximately 30,000 Muslim women and children were forcibly transferred from the enclave.
                                </div>
                            </div>

                            <div class="col-lg-offset-1 col-lg-5 col-md-offset-0 col-md-6 col-sm-12">
                                <div class="home-content-image">
                                    <div class="home-content-image-group">
                                        <img src="/images/kravica-warehouse.jpg" alt="">

                                        <p class="home-content-image-caption">Etiam convallis elementum sapien, a aliquam turpis aliquam vitaeat</p>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>

                    <div class="home-content-group reverse">
                        <div class="row middle">

                            <div class="col-lg-offset-1 col-lg-5 col-md-offset-0 col-md-6 col-sm-12">
                                <div class="home-content-image">
                                    <div class="home-content-image-group">
                                        <img class="space-bottom" src="/images/kravica-warehouse.jpg" alt="">
                                    </div>

                                    <div class="home-content-image-group">
                                        <img src="/images/kravica-warehouse.jpg" alt="">

                                        <p class="home-content-image-caption">Etiam convallis elementum sapien, a aliquam turpis aliquam vitaeat</p>
                                    </div>

                                </div>
                            </div>

                            <div class="col-lg-offset-1 col-lg-4 col-md-offset-0 col-md-6 col-sm-12">
                                <div class="home-content-text special">
                                    “ The scale and nature of the murder operation, with the staggering number of killings, the systematic and organised manner in which it was carried out, the targeting and relentless pursuit of the victims, and the plain intention—apparent from the evidence—to eliminate every Bosnian Muslim male who was captured or surrendered proves beyond reasonable doubt that this was genocide… In the context of the war in the former Yugoslavia, and in the context of human history, these events are arrestive in their scale and brutality ”

                                    <span class="signature">Trial Chamber Judgement to seven high-ranking Bosnian Serb military and police officials - <br>Popović et al.</span>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>

            </div>

            <div class="home-content-light">
                <div class="container-fluid">
                    <div class="home-content-light-inner align-center">
                        <p class="home-subtitle dark">Srebrenica</p>

                        <div class="home-intro-content">
                            <h1 class="home-title dark"><span>Timeline</span> of
                                <br> a <span>Genocide</span></h1>
                        </div>

                        <router-link :to="{ name: 'story', params: { locale: this.$i18n.locale }}" class="home-button">Show me</router-link>
                    </div>
                </div>
            </div>

        </div>

        <div class="home-footer">
            <img src="/images/Logo_MIP+EU_ENG_white.png" alt="Logo MIP EU">
        </div>
    </div>

</template>

<script>

export default {
  name: 'Outro',
  data () {
    return {


    }
  },
  methods: {

  }
}
</script>

